import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { Contact, PaginationModel } from "../../ContactManager/model/contact";
import { updateUserAccountAssignments, fetchUserAccountAssignments } from "./asyncThunks";



export const initialAccountAssignmentsState = {
    contacts: [] as Contact[],
    pagination: {
        startRow: 0,
        rowsPerPage: 10,
        rowsPerPageOptions: [10, 20, 50, 100],
        totalRowCount: 0,
    } as PaginationModel,
};

export const userAccountAssignmentsSlice = createSlice({
    name: "userAccountAssignments",
    initialState: initialAccountAssignmentsState,
    reducers: {
        onChangeContactPage: (state, action): void => {
            state.pagination.startRow = action.payload;
        },
        onChangeContactRowPerPage: (state, action): void => {
            state.pagination.rowsPerPage = action.payload;
        },
    },
    extraReducers: {
        [`${fetchUserAccountAssignments.fulfilled}`]: (state, action): void => {
            state.contacts = action.payload;
            state.pagination.startRow = 0;
            state.pagination.totalRowCount = state.contacts.length;
        },
        [`${updateUserAccountAssignments.fulfilled}`]: (state, action): void => {
            state.contacts = action.payload;
            state.pagination.startRow = 0;
            state.pagination.totalRowCount = state.contacts.length;
        },
    },
});

// Actions
export const { onChangeContactPage, onChangeContactRowPerPage } = userAccountAssignmentsSlice.actions;

// Selectors
export const userAccountAssignmentsSelector = (state: RootState) => state.userAccountAssignments.contacts;

export const userAccountAssignmentsPaginationSelector = (state: RootState): PaginationModel =>
    state.userAccountAssignments.pagination;

